import { useMemo } from 'react';

import {
  useSuspenseGetAccounts,
  useSuspenseGetApplication,
  useSuspenseGetIwocapayPaymentCaptured,
  useSuspenseGetIwocapayPaymentLater,
} from '../../../api/lending/lapiHooks.suspense';
import {
  getApplicationState,
  getTotalScheduledPayments,
} from '../Dashboard.helpers';
import { useSuspenseApplicationProcessor } from './useSuspenseApplicationProcessor';

export function useApplicationState() {
  const { application: rawApplication } = useSuspenseGetApplication();
  const { accounts } = useSuspenseGetAccounts();
  const { buyerPayLinks } = useSuspenseGetIwocapayPaymentLater();
  const { capturedPayments } = useSuspenseGetIwocapayPaymentCaptured();

  // Process open applications
  const shouldProcess =
    rawApplication?.status === 'open' &&
    rawApplication?.requested_products?.some(
      (p) => p.product_type === 'iwocapay',
    );

  useSuspenseApplicationProcessor({
    applicationStatus: shouldProcess ? rawApplication?.status : undefined,
  });

  return useMemo(() => {
    if (!accounts?.accounts || !buyerPayLinks || !rawApplication) {
      return null;
    }

    const capturedPaymentsData = capturedPayments || [];
    const totalScheduledAmount = getTotalScheduledPayments(
      buyerPayLinks,
      capturedPaymentsData,
    );

    return getApplicationState({
      accounts: accounts.accounts,
      payLinks: buyerPayLinks,
      application: rawApplication,
      totalScheduledAmount,
      capturedPayments: capturedPaymentsData,
    });
  }, [accounts, buyerPayLinks, rawApplication, capturedPayments]);
}
